export interface ISignerState {
  envelope?: IEnvelope;
  zoom: number;
  signatureText: string;
  signaturePendingPage?: number;
  signaturePendingIndex?: number;
  initials: string;
  showSignatureModal: boolean;
  unsignedBlocksByPage: Array<Array<IBlock>>;
  signedBlocksByPage: Array<Array<IBlock>>;
  isSubmitting: boolean;
  alreadySigned: boolean;
  termsAccepted: boolean;
  showExitSigningModal: boolean;
}

export interface IConfig {
  areLegalLinksVisible: boolean;
  senderUi: {
    sendRedirectUrl: string;
  };
  eSignAgreementUrl: string;
  dateFormat: DateFormatType;
}

export enum DateFormatType {
  Default = 'MM/DD/YYYY',
  DayMonthYear = 'DD/MM/YYYY',
  YearMonthDay = 'YYYY/MM/DD',
}

export interface IEnvelope {
  envelopeId: string;
  documents: IDocument[];
  signer: ISigner;
  expiration: string;
  status: string;
  config: IConfig;
  pageDimensions: {
    height: number;
    width: number;
  };
}

export interface IThumbnail {
  page: number;
  width: number;
  url: string;
}

export interface IPageDimension {
  height: number;
  width: number;
}

export interface IDocument {
  documentId: string;
  fileName: string;
  url: string;
  numberOfPages: number;
  pageThumbnails: IThumbnail[];
  blocks: IBlock[];
  blockGroups: IGroup[];
  pages: IPageDimension[];
  order: number;
}
export interface IBlock {
  blockId: string;
  pageNumber: number;
  documentId: string;
  blockType: string;
  status: string;
  x: number;
  y: number;
  value?: string | boolean | null;
  width?: number;
  height?: number;
  required?: boolean;
  fontType?: string;
  fontSize?: number;
  groupId?: string;
  signed?: boolean;
  readyOnly?: boolean;
}

export interface IGroup {
  type: string;
  id: string;
  documentId: string;
  envelopeId: string;
  pageNumber: number;
  blockIds: string[];
  validation: {
    rule: 'gte' | 'lte' | 'eq' | 'bt';
    value: number;
    valueB?: number;
  };
  readyOnly?: boolean;
}

export interface ISigner {
  signerId: string;
  firstName: string;
  lastName: string;
  middleName: string | null;
  signingStatus: string;
  executedDocuments: Array<IExecutedDocument>;
  dateSigned: string;
  title?: string;
  signingSettings?: ISignatureSettings;
  oktaUserId?: boolean;
}

export interface IExecutedDocument {
  url: string;
  documentId: string;
  fileName: string;
  order: number;
}

export interface ISignatureSettings {
  signatureValue?: string;
  initialsValue?: string;
  signatureFont?: string;
  signatureType?: 'text' | 'image';
  saveSigningSettings?: boolean;
  initialsImageBase64?: string;
  signatureImageBase64?: string;
  signatureText?: string;
  initialsText?: string;
}
